import { render, staticRenderFns } from "./Supporter.vue?vue&type=template&id=3c354fd5&scoped=true&lang=pug&"
import script from "./Supporter.vue?vue&type=script&lang=js&"
export * from "./Supporter.vue?vue&type=script&lang=js&"
import style0 from "./Supporter.vue?vue&type=style&index=0&id=3c354fd5&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c354fd5",
  null
  
)

export default component.exports